export default __webpack_public_path__ + "static/media/one.91b87d21.svg";